import { ENDPOINT_BASE_URL } from "../../configs/config";

let cachedToken = null;
let tokenPromise = null;

export const fetchJWT = async () => {
  if (cachedToken) {
    return cachedToken;
  }
  if (tokenPromise) {
    return tokenPromise;
  }

  tokenPromise = (async () => {
    const response = await fetch(`${ENDPOINT_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: "admin",
        password: "admin",
      }),
    });

    if (!response.ok) {
      tokenPromise = null;
      throw new Error("Login failed");
    }

    const data = await response.json();
    cachedToken = data.access_token || null;
    tokenPromise = null;
    return cachedToken;
  })();

  return tokenPromise;
};
